export default __webpack_public_path__ + "media/04eac63434cae45fa0e844f247d4ad54afc8c6bea77e9e43438ae15458b6617d.svg";